export default __webpack_public_path__ + "static/media/Squash-Court.7568767c.webp";